import styles from "./DeliveryData.module.scss";

const DeliveryData: React.FC = () => {
  return <div className={styles.body}>Delivery Data</div>;
};

export default DeliveryData;
